import {checkAuth, getAuthData, rehydrateAuthData} from '@utils/auth.js'
import {BUILD_TIME, BUILD_VERSION} from './buildInfo.js'

export function detectStandaloneMode() {
  if (typeof window === 'undefined') return false

  const navigatorStandalone = window.navigator?.standalone === true
  const mediaStandalone = typeof window.matchMedia === 'function'
    ? window.matchMedia('(display-mode: standalone)').matches
    : false

  return navigatorStandalone || mediaStandalone
}

export function getRuntimeMode() {
  return detectStandaloneMode() ? 'standalone' : 'browser'
}

export function getCurrentRoute() {
  if (typeof window === 'undefined') return '/'
  return `${window.location.pathname || '/'}${window.location.search || ''}`
}

export function getAuthStateSummary() {
  const auth = getAuthData()

  return {
    isAuthenticated: checkAuth(),
    hasToken: Boolean(auth?.token),
    expiresAt: auth?.expiresAt || null,
    plan: auth?.user?.plan || null,
    status: auth?.user?.status || null,
    userId: auth?.user?._id || null
  }
}

export function getServiceWorkerStateSummary() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return {supported: false, controlled: false, state: 'unsupported'}
  }

  const controllerState = navigator.serviceWorker.controller?.state || null

  return {
    supported: true,
    controlled: Boolean(navigator.serviceWorker.controller),
    state: controllerState || 'ready'
  }
}

export function collectRuntimeDiagnostics() {
  return {
    buildVersion: BUILD_VERSION,
    buildTime: BUILD_TIME,
    runtimeMode: getRuntimeMode(),
    isStandalone: detectStandaloneMode(),
    route: getCurrentRoute(),
    auth: getAuthStateSummary(),
    serviceWorker: getServiceWorkerStateSummary(),
    online: typeof navigator !== 'undefined' ? navigator.onLine !== false : true
  }
}

export function bootstrapRuntimeState() {
  const auth = rehydrateAuthData()
  const diagnostics = collectRuntimeDiagnostics()

  if (typeof window !== 'undefined') {
    window.__APP_RUNTIME__ = {
      bootstrappedAt: new Date().toISOString(),
      auth,
      diagnostics
    }
  }

  return diagnostics
}
